import {$controller} from "rapid/index";
import {delay, clone, includes, forEach} from "lodash";
import {SetConfigurationController} from "./set-configuration/set-configuration";
import SetConfigurationTemplate from "./set-configuration/set-configuration.html";
import {ApplyVersionController} from "./apply-version/apply-version";
import ApplyVersionTemplate from "./apply-version/apply-version.html";
import {SetPasswordController} from "./set-password/set-password";
import SetPasswordTemplate from "./set-password/set-password.html";
// let process = require("process");

const dependencies = ["$Company", "$Configuration", "$Deployment", "$companies",
    "$Booth", "$SetConfigToBooth", "$Version", "$ApplyAppVersion"];


export default class Controller extends $controller {

    constructor($injector, $scope, $state, $interval, $auth, $ToastService) {
        "ngInject";
        super($injector, dependencies);
        this.$state = $state;
        this.$scope = $scope;
        this.$auth = $auth;
        this.toastService = $ToastService;
        this.$scope.loading = true;
        this.$scope.query = {page: 1, search: ""};
        this.$scope.filter = {};
        this.$scope.selectFilter = {};
        this.$scope.boothsArray = [];
        this.$scope.pageCount = 0;
        this.$scope.canAddMore = true;
        this.socket = null;
        this.channelName = "";
        this.$scope.logOrder = () => {
            this.$scope.query.ordering = this.$scope.query.order.replace("_", "");
            this.query(true);
        };

        this.searchByKeyPress = (event) => {
            const keyName = event.key;
            const letters = "abcdefghijklmnopqrstuvwxyz";
            if (letters.indexOf(keyName) !== -1 && (document.activeElement.tagName === "BODY" || document.activeElement.tagName === "A")) {
                this.$scope.$apply(() => {
                    this.$scope.filter.show = true;
                    if (!this.$scope.query.search) {
                        this.$scope.query.search = keyName;
                    }
                });
                delay(() => {
                    document.getElementById("search-field").focus();
                }, 100);
            }
        };

    }

    $onInit() {
        this.$scope.filter.show = false;
        this.$scope.$watch("query.search", angular.bind(this, this.onQueryFilterChange));
        document.addEventListener("keypress", this.searchByKeyPress);
        this.startWebSocket();
    }

    startWebSocket() {
        this.socket = new WebSocket(`wss://${ process.env.DEVSERVER_PROXY_TARGET ? process.env.DEVSERVER_PROXY_TARGET.split("//")[1] : "cloud.upreach.com"}/ws/user/?token=${this.$auth.getToken().split(" ")[1]}`);
        this.socket.onmessage = (e) => {
            try {
                let data = JSON.parse(e.data);
                switch (data.action) {
                    case "booth-update":
                        for(let i = 0; i < this.$scope.boothsArray.length; i++) {
                            if (this.$scope.boothsArray[i].booth_id === data.entity.booth_id ){
                                this.$scope.boothsArray[i] = data.entity;
                            }
                        }
                        this.$scope.$apply(() => this.$scope.boothsArray);
                        return;
                    case "booth-delete":
                        for(let i = 0; i < this.$scope.boothsArray.length; i++) {
                            if (this.$scope.boothsArray[i].booth_id === data.entity.booth_id ){
                                this.$scope.boothsArray.splice(i, 1);
                            }
                        }
                        this.$scope.$apply(() => this.$scope.boothsArray);
                        return;
                    case "send-channel-name":
                        this.channelName = data.channel_name;
                        return;
                }
            } catch(e) {
                console.log(e);
            }
        };
        this.socket.onopen = () => {
            console.log("CONNECTION Opened!", this.socket);
        };
        this.socket.onclose = () => {
            console.log("CONNECTION Closed!", this.socket);
            this.socket = null;
            setTimeout(() => {
                if (this.startWebSocket) {
                    console.log("CONNECTION Try to reconnect!", this.socket);
                    this.startWebSocket();
                }
            }, 5000);
        };
        this.socket.onerror = (e) => {
            console.log("CONNECTION Error!", e);
        };
    }

    $onDestroy() {
        this.socket.close();
        this.startWebSocket = null;
        this.socket = null;
        document.removeEventListener("keypress", this.searchByKeyPress);
    }

    query(isNew) {
        this.$scope.query.page = isNew ? 1 : this.$scope.query.page;
        this.$scope.loading = true;
        var booths = this.$Booth.query(this.$scope.query);

        Promise.all([booths.$promise]).then(() => {
            this.$scope.loading = false;

            isNew ? this.$scope.boothsArray = booths : this.$scope.boothsArray.push(...booths);
            this.$scope.pageCount = booths._meta.page_count;
            this.$scope.canAddMore = this.$scope.query.page !== this.$scope.pageCount;
            this.sendBoothIds();

            this.$scope.$apply();
        });
    }

    removeFilter() {
        this.$scope.filter.show = false;
        this.$scope.query.search = "";
    }

    showFilter() {
        this.$scope.filter.show = true;
        delay(() => {
            document.getElementById("search-field").focus();
        }, 100);

    }

    addMoreItems() {
        this.$scope.query.page++;
        this.query();
    }

    sendBoothIds() {
        if (!this.socket) {
            return;
        }
        let ids = [];
        forEach(this.$scope.boothsArray, (b) => {
            ids.push(b.booth_id);
        });
        this.socket.send(JSON.stringify({action: "current-channel", channel_name: this.channelName, booth_ids: ids}));
    }

    onQueryFilterChange() {
        this.$scope.query.page = 1;
        const newValue = clone(this.$scope.query.search);
        this.$scope.loading = true;
        this.searhDelayTimeout = setTimeout(() => {
            const prewValue = clone(this.$scope.query.search);
            if (prewValue === newValue) {
                clearTimeout(this.searhDelayTimeout);
                this.query(true);
            }
        }, 500);
    }

    updateBooth(booth) {
        let id = booth.url.split("/")[booth.url.split("/").length - 2];
        this.$scope.loading = true;
        this.$auth.$http({
            url: `/api/booths/${id}/`,
            method: "PUT",
            data: {booth_type: booth.booth_type, company: booth.company}
        }).then(() => {
            this.$scope.loading = false;
        }).catch(() => {

        });
    }

    setConfigurationId(item) {
        let parentEl = angular.element(document.body);
        this.$mdDialog.show({
            parent: parentEl,
            title: "Create new configuration",
            controller: SetConfigurationController,
            template: SetConfigurationTemplate,
            targetEvent: item,
            locals: {
                callback: (configuration) => { this.applyConfiguration(configuration, item); },
                activeDeployment: item.deployment,
                configurationsArray: this.$scope.configurationsArray
            }
        });
    }

    openVersionDialog(item) {
        let os_name = {os_name:"Windows"};
        if (item.os_name) {
            Object.assign(os_name,item.os_name);
        }else{
            if (item.booth_id.includes("AN-")){
                Object.assign(os_name,{os_name:"Android"});
            }
        }
        let versions = this.$Version.query(os_name);
        versions.$promise.then((resp) => {
            let parentEl = angular.element(document.body);
            this.$mdDialog.show({
                parent: parentEl,
                title: "Create new configuration",
                controller: ApplyVersionController,
                template: ApplyVersionTemplate,
                targetEvent: item,
                locals: {
                    callback: (version) => { this.applyAppVersion(version, item); },
                    versions: resp,
                    currentVersion: item.app_version
                }
            });
        }).catch(() => {
            this.toastService.showError(`Can't get versions list.`, 5000);
        });
    }

    openPasswordDialog(item, isExit) {
        let parentEl = angular.element(document.body);
        this.$mdDialog.show({
            parent: parentEl,
            title: isExit ? "Set Exit password to booth" : "Set App password",
            controller: SetPasswordController,
            template: SetPasswordTemplate,
            targetEvent: item,
            locals: {
                callback: (password) => { this.applyPassword(password, item, isExit); },
                title: isExit ? "Set exit password to booth" : "Set app password",
                password: isExit ? (item.exit_password || null) : (item.password || null)
            }
        });
    }

    applyConfiguration(config, booth) {
        let q = {
            configuration_url: config.config,
            booth_id: booth.booth_id
        };
        this.$SetConfigToBooth.update(q).$promise.then(()=> {
            this.toastService.showSimple(`Configuration successfully applied.`, 5000);
            this.query(true);
        }).catch(() => {
            this.toastService.showError(`Can't apply configuration.`, 5000);
        });
    }

    applyAppVersion(version, booth) {
        let q = {
            version: version,
            booth_id: booth.booth_id
        };
        this.$ApplyAppVersion.update(q).$promise.then(()=> {
            this.toastService.showSimple(`New version applied.`, 5000);
            this.query(true);
        }).catch(() => {
            this.toastService.showError(`Can't apply version.`, 5000);
        });
    }

    applyPassword(password, booth, isExit) {
        let q = {
            new_password: password,
            booth_id: booth.booth_id
        };

        let auth = isExit ?
            this.$auth.$http({
                url: "/api/booth-set-exit-password/",
                method: "PUT",
                data: q
            }) :
            this.$auth.$http({
                url: "/api/booth-set-app-password/",
                method: "PUT",
                data: q
            });
        auth.then(() => {
            this.toastService.showSimple(`Password set!`, 5000);
        }).catch(() => {
            this.toastService.showError(`Can't set password.`, 5000);
        });
    }

    isAvailableForUser(booth) {
        const userRoles = this.$auth.getUser().groups_names;

        if (!booth.deployment )  {
            return false;
        }

        if (includes(userRoles, "Admin") || includes(userRoles, "Manager")) {
            return true;
        }

        if (booth.booth_type !== "single") {
            return true;
        }

        return booth.deployment.is_active;
    }

    updateTeamViewer(booth, isClose) {
        this.$auth.$http({
            url: "/api/booth-teamviewer/",
            method: "PUT",
            data: {action: isClose ? "kill-teamviewer" : "start-teamviewer", booth_id: booth.booth_id }
        }).then(() => {
            this.toastService.showSimple(`Team Viewer ${isClose ? "close" : "open"} request sent`, 5000);
        }).catch(() => {
            this.toastService.showError(`Can't send request!`, 5000);
        });
    }

    updateDropbox(booth, isClose) {
        this.$auth.$http({
            url: "/api/booth-dropbox/",
            method: "PUT",
            data: {action: isClose ? "kill-dropbox" : "start-dropbox", booth_id: booth.booth_id }
        }).then(() => {
            this.toastService.showSimple(`Dropbox ${isClose ? "close" : "start"} request sent`, 5000);
        }).catch(() => {
            this.toastService.showError(`Can't send request!`, 5000);
        });
    }

    canClientUpdateViewer(booth) {

        if (booth.booth_type === "single" && this.isClient()) {
            return false;
        }

        return true;
    }

    removeDeployment(item) {
        let confirm = this.$mdDialog.confirm()
            .title("Remove Deployment?")
            .textContent(`This will remove “${item.deployment.name}” and all its Configurations from ${item.booth_id}. It will remain in the 
            UpReach Cloud and can be downloaded again any time.`)
            .ariaLabel("Deployment")
            .ok("REMOVE")
            .cancel("CANCEL");

        this.$mdDialog.show(confirm).then(() => {
            this.$auth.$http({
                url: "/api/booth-remove-deployment/",
                method: "PUT",
                data: {deployment_url: item.deployment.url, booth_id: item.booth_id }
            }).then(() => {
                this.toastService.showSimple(`Deployment removed`, 5000);
            }).catch(() => {
                this.toastService.showError(`Can't remove deployment!`, 5000);
            });
        });
    }

    changeCompany(value, item) {
        this.updateBooth(item);
    }

    onSearchBlur() {
        if (!this.$scope.query.search) {
            this.$scope.filter.show = false;
        }
    }

    isClient() {
        return this.$auth.isRole("Client") || this.$auth.isRole("Sub-User");
    }

    getBoothStatusClass(status) {
      if (status.indexOf("online") !== -1) {
          return "online";
      } else if (status.indexOf("error") !== -1) {
          return "error";
      } else {
          return "";
      }
    }

    isBoothOnline(status) {
        return status.indexOf("online") !== -1;
    }
}



// WEBPACK FOOTER //
// ./sources/components/booths/booths.controller.js